import styled from "styled-components";
import { Accordion, AccordionSummary, AccordionDetails } from "@mui/material";

export const AccordionStyled = styled(Accordion)`
  background-color: transparent;
  box-shadow: none;
  border: none;

  &.MuiAccordion-root:before {
    background-color: transparent;
  }

  &.MuiPaper-elevation1 {
    box-shadow: none;
  }
`;

export const AccordionSummaryStyled = styled(AccordionSummary)`
  &.MuiAccordionSummary-root {
    padding: 0;
    margin: 0;
    background-color: transparent;

    &.Mui-expanded {
      min-height: 0;
    }
  }

  & .MuiAccordionSummary-content.Mui-expanded {
    margin: 0;
  }

  & .MuiAccordionSummary-expandIcon {
    color: "#fff";
  }
`;

export const AccordionDetailsStyled = styled(AccordionDetails)`
  padding-left: 0;
  padding-right: 0;
  background-color: transparent;
  flex-direction: column;
`;

export const FooterContainer = styled.footer`
  background: #0f438a;
  min-height: 18.375rem;
  width: 100%;
  z-index: 1000;
  align-items: center;
  padding: 48px 0 48px;
`;

export const NavLink = styled.a`
  text-decoration: none;
  font-family: Mulish, sans-serif;
  display: table;
  margin-bottom: 6px;
  color: #fff;
  font-size: 13px;
  word-wrap: break-word;
  overflow-wrap: break-word;

  &:hover {
    text-decoration: underline;
  }
`;

export const Title = styled.p`
  word-wrap: break-word;
  overflow-wrap: break-word;
`;

export const Content = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding-left: 20px;
  padding-right: 20px;
`;
